import React from 'react';

import { appMethod as app } from '@utils/app';
import ScratchClass from '@utils/scratch';
import { getCurrentPageQueryParams, convertLineStyleData } from '@utils/tools';
import utils from '@utils/util';

import { Recommend } from 'src/common/recommend/Recommend';
import { TopNav } from '@common/top-nav/TopNav';
import OfficialPage from '../OfficialPage';

import './PresellPaySuccess.less';


export default class PresellPaySuccess extends OfficialPage {
  state = {
    status: 0, // 0: 普通页面 1:有集集乐的情况
    orderId: '',
    franchiseeId: '',
    final_payment_start_time: '',
    presell_status: '',
    collectBenefitData: {}, // 集集乐数据
    starData: [], //集集乐的星 light:已集样式 dark:未集样式
    isFail: true, //刮刮乐未中奖
    isWinning: true, //刮刮乐中奖
    isComfort: true, //刮刮乐安慰奖
    isWhole: true, //刮奖区域是否显示
    scratchId: '', //活动号
    isShowteam: false,
    winingTitle: '',
    isScroll: true, //刮刮乐当在 canvas 中移动时且有绑定手势事件时禁止屏幕滚动以及下拉刷新
    ifWxCoupon: false,
    presell_bargain: '',
    timestamp: '',
    signature: '',
    ifGetComfort: false,
    formid: []
  }
  
  recommendRef = React.createRef();

  constructor(props) {
    super(props);
    document.title = '支付成功';
  }

  componentDidMount(options = getCurrentPageQueryParams()) {
    let that = this
    if (options.collectBenefit == 1) {
      that.getCollectBenefitData(options.detail)
      that.setData({
        status: 1
      })
    }
    that.setData({
      orderId: options.detail,
      franchiseeId: options.franchisee || '',
      is_group: options.is_group || '',
      code: options.code || '',
      is_newAppointment: options.is_newAppointment || '',
      presell_status: options.presell_status || ''
    })
    that.getOrderDetail()
    this.getAppECStoreConfig()
    that.getGoldenData(options.detail)
    let systemInfo = app.globalData.systemInfo || {}
    let width = (558 * systemInfo.windowWidth) / 750
    let height = (258 * systemInfo.windowWidth) / 750
    that.scratch = new ScratchClass(that, {
      canvasWidth: width,
      canvasHeight: height,
      imageResource:
        app.getSiteBaseUrl() +
        '/index.php?r=Download/DownloadResourceFromUrl&url=https://chn.jisuapp.cn/zhichi_frontend/static/webapp/images/scratchMovie.png',
      maskColor: 'red',
      r: 18,
      callback: () => {
        that.setData({
          hideCanvas: true
        })
        if (that.data.ifWxCoupon) {
          setTimeout(function() {
            that.toAddCard()
          }, 500)
        }
      },
      imgLoadCallback: () => {
        setTimeout(function() {
          that.setData({
            isShowteam: true
          })
        }, 10)
      }
    })
  }

  touchStart = e => {
    if (!this.isStart) return
    let pos = this.drawRect(e.touches[0].x, e.touches[0].y)
    this.ctx.clearRect(pos[0], pos[1], pos[2], pos[2])
    this.ctx.draw(true)
  }
  touchMove = e => {
    if (!this.isStart) return
    let pos = this.drawRect(e.touches[0].x, e.touches[0].y)
    this.ctx.clearRect(pos[0], pos[1], pos[2], pos[2])
    this.ctx.draw(true)
  }
  touchEnd = e => {
    if (!this.isStart) return
    let { canvasWidth, canvasHeight, minX, minY, maxX, maxY } = this
    if (maxX - minX > 0.5 * canvasWidth && maxY - minY > 0.5 * canvasHeight) {
      this.ctx.draw()
      this.endCallBack && this.endCallBack()
      this.isStart = false
      this.page.setData({
        isScroll: true
      })
    }
  }
  getGoldenData = id => {
    let that = this
    app.sendRequest({
      url: '/index.php?r=appLotteryActivity/getTimeAfterConsume',
      method: 'post',
      data: {
        order_id: id,
        sub_app_id: that.data.franchiseeId
      },
      success: function (data) {
        if (data.data) {
          if (that.data.code) {
            that.setData({
              isWhole: true
            })
          } else {
            that.setData({
              isWhole: false,
              scratchId: data.data
            })
          }
        } else {
          that.setData({
            isWhole: true
          })
        }
        if (data.integral) {
          //支付获取积分
          that.setData({
            rewardPointObj: {
              showModal: true,
              count: data.integral,
              callback: ''
            }
          })
        }
      }
    })
  }
  showAreaClick = () => {
    let that = this
    that.setData({
      isShowteam: false
    })
    app.sendRequest({
      url: '/index.php?r=appLotteryActivity/lottery',
      hideLoading: true,
      data: {
        activity_id: that.data.scratchId,
        sub_app_id: that.data.franchiseeId
      },
      success: function (res) {
        let data = res.data
        that.scratch.start()
        if (data.title == '谢谢参与') {
          that.setData({
            isFail: false
          })
        } else {
          let params = {
            ifWxCoupon: data.card_id || false,
            timestamp: data.timestamp || '',
            signature: data.signature || ''
          }
          if (data.is_comfort) {
            params['isComfort'] = false
          } else {
            params['isWinning'] = false
            params['winingTitle'] = data.title
          }
          that.setData(params)
        }
      }
    })
  }
  onShareAppMessage = res => {
    var that = this
    let franchiseeParam = this.data.franchiseeId
      ? '&franchisee=' + this.data.franchiseeId
      : ''
    return {
      path:
        '/awardManagement/pages/scratch/scratch?id=' +
        that.data.scratchId +
        franchiseeParam,
      success: function (res) {
        app.sendRequest({
          url: '/index.php?r=appLotteryActivity/getTime',
          data: {
            activity_id: that.data.scratchId,
            type: 'share',
            sub_app_id: that.data.franchiseeId
          },
          success: function (res) { }
        })
      },
      fail: function (res) { }
    }
  }
  getCollectBenefitData = id => {
    let that = this
    app.sendRequest({
      url: '/index.php?r=AppMarketing/CollectmeSendCoupon',
      data: {
        order_id: id,
        sub_app_id: that.data.franchiseeId
      },
      hideLoading: true,
      success: function (res) {
        let starData = []
        for (var i = 0; i < res.data.star_num; i++) {
          starData.push('light')
        }
        for (var i = 0; i < res.data.collect_num - res.data.star_num; i++) {
          starData.push('dark')
        }
        that.setData({
          collectBenefitData: res.data,
          starData: starData
        })
      }
    })
  }
  goToHomepage = () => {
    let router = app.getHomepageRouter()
    app.reLaunch({
      url: '/pages/' + router + '/' + router
    })
  }
  goToOrderDetail = () => {
    let that = this
    let presellPath =
      '/presell/pages/presellOrderDetail/presellOrderDetail?detail=' +
      that.data.orderId +
      (that.data.franchiseeId ? '&franchisee=' + that.data.franchiseeId : '')
    that.saveUserFormId(presellPath, 1)
  }
  getOrderDetail = () => {
    var that = this
    app.getOrderDetail({
      data: {
        order_id: that.data.orderId,
        sub_shop_app_id: that.data.franchiseeId
      },
      success: function (res) {
        var form_data = res.data[0].form_data,
          final_payment_start_time =
            form_data.presell_shopping_cart[0].final_payment_start_time * 1,
          presell_bargain = form_data.total_bargain
        final_payment_start_time = utils.formatTimeYMD(
          new Date(final_payment_start_time * 1000),
          'MM月DD日 hh:mm'
        )
        that.setData({
          orderInfo: form_data,
          presell_bargain: presell_bargain,
          final_payment_start_time: final_payment_start_time
        })
      }
    })
  }
  toAddCard = () => {
    let _data = this.data,
      wxcouponId = _data.ifWxCoupon,
      that = this
    app.addCard({
      cardList: [
        {
          cardId: wxcouponId,
          cardExt:
            '{"nonce_str":"' +
            _data.timestamp +
            '","timestamp":"' +
            _data.timestamp +
            '", "signature":"' +
            _data.signature +
            '"}'
        }
      ],
      success: function (res) {
        that.setData({
          ifWxCoupon: false,
          ifGetComfort: true
        })
        app.sendRequest({
          url: '/index.php?r=appLotteryActivity/recvWeChatCoupon',
          data: {
            card_id: res.cardList[0].cardId,
            sub_app_id: _data.franchisee,
            activity_id: _data.scratchId
          },
          success: function (res) {
            app.showModal({
              title: '提示',
              content: '领取卡券成功',
              showCancel: false
            })
          }
        })
      }
    })
  }
  getAppECStoreConfig = () => {
    app.getAppECStoreConfig(res => {
      this.setData({
        storeStyle: res.color_config,
        hasRecommendConfig: res.recommend_config ? false : true
      })
    }, this.data.franchiseeId)
  }
  formSubmit_collect = e => {
    let formid = this.data.formid
    formid.push(e.detail.formId)
  }
  saveUserFormId = (path, isRedirect) => {
    app.showLoading({
      title: '加载中'
    })
    var that = this
    app.sendRequest({
      url: '/index.php?r=api/AppMsgTpl/saveUserFormId',
      method: 'post',
      data: {
        sub_shop_app_id: that.data.franchiseeId || '',
        form_id: that.data.formid || []
      },
      complete: function () {
        app.hideLoading()
        app.turnToPage(path, isRedirect)
        that.setData({
          formid: []
        })
      }
    })
  }

  render() {
    const {
      rewardPointObj,
      showGetUserInfo,
      storeStyle,
      hasRecommendConfig,
      orderInfo,
      goods,
      presell_status,
      final_payment_start_time,
      franchiseeId
    } = this.state
    return (
      <div className="official-page presell-pay-success">
        <TopNav title="支付成功"/>
        <React.Fragment>
          <div>
            {hasRecommendConfig && (
              <div
                className="normal-area"
                style={convertLineStyleData('background:' + storeStyle.theme)}
              >
                <div
                  className="order-price-box"
                  style={convertLineStyleData('background:' + storeStyle.theme)}
                >
                  <div className="order-success">
                    <img
                      className="goods-complete-succes"
                      src="http://cdn.jisuapp.cn/static/webapp/images/xcx-goods/goods-complete-success.png"
                    />
                  </div>
                </div>
                <div style={convertLineStyleData('background:#fff;')}>
                  <img
                    className="goods-complete-bg"
                    src="http://cdn.jisuapp.cn/static/webapp/images/xcx-goods/goods-complete-bg.png"
                  />
                </div>
              </div>
            )}
            <div className="normal-area-status">
              {presell_status == 3 ? (
                <React.Fragment>
                  <div className="order-price">
                    {'¥' + orderInfo.final_order_total_price}
                  </div>
                  <div className="pay-tips">尾款支付成功</div>
                  <div style={convertLineStyleData('padding-bottom:60rpx;')}>
                    <div className="btn-area">
                      <div onClick={this.goToHomepage} className="isRelative">
                        继续购物
                      </div>
                      <div onClick={this.goToOrderDetail} className="isRelative">
                        查看订单
                      </div>
                    </div>
                  </div>
                </React.Fragment>
              ) : (
                  <React.Fragment>
                    <div className="order-price">
                      {'¥' + (orderInfo ? orderInfo.bargain_order_total_price : '')}
                    </div>
                    <div className="pay-tips">定金支付成功</div>
                    <div className="icons">
                      <div></div>
                      <div></div>
                    </div>
                    <div style={convertLineStyleData('height:296rpx;')}>
                      <div className="order-tips">
                        <div>请在我的预售中支付尾款</div>
                        <div>
                          <span>{final_payment_start_time}</span>开始支付尾款
                      </div>
                      </div>
                      <div className="btn-area">
                        <div onClick={this.goToHomepage} className="isRelative">
                          继续购物
                        </div>
                        <div onClick={this.goToOrderDetail} className="isRelative">
                          查看订单
                        </div>
                      </div>
                    </div>
                  </React.Fragment>
                )}
            </div>
          </div>
          <Recommend id="component-recommend" franchiseeId={franchiseeId} ref={this.recommendRef} />
        </React.Fragment>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/official-page/presell-pay-success/PresellPaySuccess.jsx